import { ReactNode } from 'react';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className="mb-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 style={{ fontSize: 32, fontWeight: 400, margin: 0, lineHeight: 1.2, color: '#1a1a1a' }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{ fontSize: 18, fontWeight: 400, margin: 0, marginTop: 4, color: '#666' }}>
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="flex items-center gap-3 flex-wrap">{actions}</div>}
      </div>
    </header>
  );
}

export default PageHeader;
